<div class="relative">
  <div
    class="flex flex-col w-[72px] bg-dark text-white p-4 transition-all duration-75 relative justify-between h-screen"
    [ngClass]="{ '!w-[260px]': isExpanded }"
    (mouseenter)="onSidebarHover(true)"
    (mouseleave)="onSidebarHover(false)"
  >
    <div>
      <div
        (click)="isExpanded = !isExpanded"
        class="absolute top-[15%] right-0 translate-x-1/2 -translate-y-1/2 cursor-pointer transition-transform duration-200 hover:scale-110 z-50"
      >
        <span
          class="flex items-center justify-center cursor-pointer rounded bg-primary h-[24px] w-[24px] transition-transform duration-200 hover:scale-110"
          [ngClass]="isExpanded ? 'pi pi-angle-left' : 'pi pi-angle-right'"
        ></span>
      </div>

      @if (isExpanded) {
        <div class="py-5">
          <a [routerLink]="homepageUrl">
            @if (tenant === 'dpp') {
              <img class="w-[80%]" src="assets/logos/dpp-logo.svg" alt="dpp" />
              <img
                class="w-[60%]"
                src="assets/logos/powered-by-regenesis.svg"
                alt="powered-by-regenesis"
              />
            } @else {
              <img src="assets/logos/logo-light.svg" alt="regenesis" />
            }
          </a>
        </div>
      }

      @if (!isExpanded) {
        <div class="py-5 text-center">
          <a [routerLink]="homepageUrl">
            @if (tenant === 'dpp') {
              <img class="w-[45px]" src="assets/logos/dpp-logo-min.svg" alt="dpp" />
            } @else {
              <img src="assets/logos/logo-min-light.svg" alt="regenesis" />
            }
          </a>
        </div>
      }
    </div>

    <div>
      <div class="h-[60vh] flex flex-col justify-between">
        <div
          class="flex-1 overflow-y-auto overflow-x-hidden scrollbar-hide relative"
          #navContainer
          (scroll)="onNavScroll()"
        >
          <nav class="flex flex-col">
            @for (item of items; track item) {
              @if (checkPermissions(item['slugs'])) {
                <div class="relative rounded" [ngClass]="{ 'w-[40px] text-center': !isExpanded }">
                  <a
                    [routerLink]="item.routerLink"
                    [ngClass]="{
                      'active-link':
                        (isMenuActive(item) && !hasActiveChild(item)) ||
                        (isMenuActive(item) && !isExpanded),
                      'active-link-parent': hasActiveChild(item) && isExpanded,
                    }"
                    class="flex gap-2 items-center my-1 p-3 rounded-md cursor-pointer !text-white hover:bg-gray transition-colors duration-200"
                    (click)="toggleMenu(item, $event)"
                  >
                    <div class="w-[20px] h-[20px] flex items-center justify-center">
                      <span [class]="item.icon" class="text-[20px] leading-none"></span>
                    </div>
                    @if (isExpanded) {
                      <span class="flex-grow mb-[-2px]">{{ item.label }}</span>
                      @if (item.items?.length) {
                        <span
                          class="pi"
                          [ngClass]="{
                            'pi-angle-down': item.expanded,
                            'pi-angle-right': !item.expanded,
                          }"
                        ></span>
                      }
                    }
                  </a>

                  @if (item.items?.length && item.expanded && isExpanded) {
                    <div class="border-l border-gray ml-3 transition-all duration-200 ease-in-out">
                      @for (subItem of item.items; track subItem) {
                        @if (checkPermissions(subItem['slugs'])) {
                          <a
                            [routerLink]="subItem.routerLink"
                            [ngClass]="{ 'active-link': isMenuActive(subItem) }"
                            class="flex items-center p-2 my-1 rounded-md cursor-pointer !text-white hover:bg-gray transition-colors duration-200"
                          >
                            <span class="ml-4 mb-[-2px]">{{ subItem.label }}</span>
                          </a>
                        }
                      }
                    </div>
                  }
                </div>
              }
            }
          </nav>

          <!-- Scroll Buttons -->

          @if (showScrollToTop && isExpanded && isHovered) {
            <div class="sticky top-2 z-30 flex justify-center">
              <span
                (click)="scrollToTop()"
                class="cursor-pointer transition-transform duration-200 hover:scale-110"
              >
                <span
                  class="flex items-center justify-center cursor-pointer rounded bg-primary h-[24px] w-[24px] transition-transform duration-200 hover:scale-110 pi pi-angle-up text-white text-xs leading-none"
                ></span>
              </span>
            </div>
          } @else if (showScrollToBottom && isExpanded && isHovered) {
            <div class="sticky bottom-2 z-30 flex justify-center">
              <span
                (click)="scrollToBottom()"
                class="cursor-pointer transition-transform duration-200 hover:scale-110"
              >
                <span
                  class="flex items-center justify-center cursor-pointer rounded bg-primary h-[24px] w-[24px] transition-transform duration-200 hover:scale-110 pi pi-angle-down text-white text-xs leading-none"
                ></span>
              </span>
            </div>
          }
        </div>
      </div>
    </div>

    <div>
      <div>
        <nav class="flex flex-col">
          <div class="relative rounded">
            @for (item of profileItems; track item) {
              @if (checkPermissions(item['slugs'])) {
                <div class="relative rounded" [ngClass]="{ 'w-[40px] text-center': !isExpanded }">
                  <a
                    [routerLink]="item.routerLink"
                    [ngClass]="{
                      'active-link': isMenuActive(item) || (isMenuActive(item) && !isExpanded),
                    }"
                    class="flex items-center gap-2 my-1 px-[8px] py-[8px] rounded-md cursor-pointer !text-white hover:bg-gray transition-colors duration-200"
                    (click)="toggleProfileMenu(item, $event)"
                  >
                    <img
                      [src]="user$()?.photo ?? bucketUrl + '/images/avatar.png'"
                      class="rounded-full w-[25px] h-[25px] object-cover"
                    />
                    @if (isExpanded) {
                      <div class="flex items-center justify-between gap-2 w-full">
                        <div>
                          <div class="text-xs font-bold">
                            {{ user$()?.firstName }} {{ user$()?.lastName }}
                          </div>
                          <div class="text-xs">
                            {{ user$()?.roleName | textTransform }}
                          </div>
                          @if (tenant !== 'dpp') {
                            <div class="text-xs italic">
                              {{ getOrganizationName() }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </a>
                </div>
              }
            }
          </div>
        </nav>
      </div>
      <div class="flex flex-col">
        <nav class="flex flex-col flex-1 overflow-y-auto scrollbar-hide">
          <div class="relative rounded">
            <div class="relative rounded" [ngClass]="{ 'w-[40px] text-center': !isExpanded }">
              <a
                (click)="logout()"
                class="flex items-center gap-2 my-1 p-3 rounded-md cursor-pointer !text-white hover:bg-gray transition-colors duration-200"
              >
                <div class="w-[20px] h-[20px] flex items-center justify-center">
                  <span class="pi pi-sign-out text-[20px] leading-none"></span>
                </div>
                @if (isExpanded) {
                  <span>Logout</span>
                }
              </a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>
